import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 w-full" style={{ maxWidth: 1240, margin: '0 auto', padding: '0 20px' }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
